<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import InventoryDetails from '../../../components/inventories/inventory-details'
import InventoryForm from '../../../components/inventories/inventory-form'
import {truncate} from "../../../helpers/utils";
import api from "../../../services/api";
import {formatDate} from "../../../helpers/inventories"
import PersonDetails from "../../../components/persons/person-details";
import PageProfile from "../../../components/pages/page-profile";
import PersonInline from "../../../components/persons/person-inline";
import InventoryImport from "../../../components/inventories/inventory-import";

export default {
  page: {
    title: "Inventaires",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    PersonInline,
    PersonDetails,
    Layout,
    PageHeader,
    InventoryDetails,
    InventoryForm,
    PageProfile,
    InventoryImport
  },
  data() {
    const canEdit = !!JSON.parse(localStorage.getItem('user')).roles.find((v) => v.name === 'admin');

    return {
      title: "Inventaires",
      items: [
        {
          text: "Inventaires",
          active: true
        },
        {
          text: "Liste",
          active: true
        }
      ],
      canEdit,
      modalTitle: '',
      selectedPages: null,
      selectedInventory: null,
      selectedPerson: null,
      isBusy: true,
      isExporting: false,
      displayPageDetails: false,
      displayDetails: false,
      displayEditForm: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {key: "inventory_number", sortable: true, label: 'Numéro d\'inventaire', thStyle: 'width: 100px'},
        {key: "exploitation_number", sortable: true, label: 'Cote libre', class: 'text-center', thStyle: 'width: 73px'},
        {key: "title", sortable: false, label: 'Titre'},
        {key: "date", sortable: true, label: 'Date'},
        {key: "authors", sortable: true, label: 'Auteur'},
        {key: "persons", sortable: true, label: 'Personne(s)'},
        {key: "format", sortable: true, class: 'text-center'},
        {key: "actions", sortable: false, class: 'text-center'},
      ],
      type: '',
      data: []
    };
  },
  mounted() {
    this.myProvider();
  },
  methods: {
    myProvider() {
      this.isBusy = true;
      this.data = [];

      const data = {
        page: this.currentPage,
        length: this.perPage,
        filter: this.filter,
        sortBy: this.sortBy,
        sortDir: (this.sortDesc ? 'desc' : 'asc'),
        with: 'date,date_end,authors,persons,pages,address,support,numerisation'
      };

      if (this.type) {
        data.advanced = {
          type: this.type
        }
      }

      return api.get('inventories', data, null, {}, 'provider').then((response) => {
        this.totalRows = response.data.total;
        this.data = response.data.data;
      }).catch(() => {
        this.totalRows = 0;
        this.data = [];
      }).finally(() => {
        this.isBusy = false;
      });
    },
    truncate(text, length, clamp) {
      return truncate(text, length, clamp);
    },
    formatAddress(item) {
      //return formatAddress(item);
      return item.commune ? item.commune.name : '';
    },
    formatDate(item) {
      return formatDate(item);
    },
    hideModal() {
      this.displayDetails = false;
      this.displayEditForm = false;
      this.selectedInventory = null;
      this.modalTitle = '';

      this.$bvModal.hide('modal-details');
      this.$bvModal.hide('modal-import');
      this.myProvider();
    },
    showDetails(item) {
      this.displayDetails = true;
      this.displayEditForm = false;
      this.selectedInventory = item;
      this.modalTitle = '<i class="bx bx-hash"></i> ' + item.inventory_number;
    },
    showEditForm(item) {
      this.displayDetails = false;
      this.displayEditForm = true;
      this.selectedInventory = item;
      this.modalTitle = '<i class="bx bx-hash"></i> ' + item.inventory_number;
    },
    showPagesDetails(pages) {
      this.displayPageDetails = true;
      this.selectedPages = pages;
    },
    exportInventories() {
      if (this.isExporting) {
        return;
      }

      this.isExporting = true;

      return api.get('inventories', {
        filter: this.filter,
        sortBy: this.sortBy,
        sortDir: (this.sortDesc ? 'desc' : 'asc'),
      }, 'export', {responseType: "blob"}).then((response) => {
        const fileLink = document.createElement('a');

        fileLink.href = window.URL.createObjectURL(new Blob([response.data],
            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        fileLink.setAttribute('download', 'export_inventaires.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();

        this.isExporting = false;
      });
    },
    onFiltered() {
      this.currentPage = 1;
    },
  },
  watch: {
    type: function () {
      this.currentPage = 1;
      this.myProvider();
    },
    currentPage() {
      this.myProvider();
    },
    filter() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    },
    sortBy() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    },
    sortDesc() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    },
    perPage() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <b-row class="mb-2">
      <b-col class="text-right">
        <b-button v-if="canEdit" variant="success" class="btn-label text-capitalize me-2" v-b-modal.modal-import>
          <i class="bx bx-import label-icon"></i> {{ $t(`components.inventories.import`) }}
        </b-button>
        <b-button variant="success" class="btn-label text-capitalize me-2" :is-loading="isExporting"
                  @click="exportInventories()">
          <i class="bx bx-export label-icon"></i> {{ $t(`components.inventories.export`) }}
        </b-button>
        <b-button v-if="canEdit" variant="primary" class="btn-label text-capitalize"
                  v-b-modal.modal-details
                  @click="showEditForm({inventory_number: ''})">
          <i class="bx bx-plus label-icon"></i> {{ $t(`general.inventory`) }}
        </b-button>
      </b-col>
    </b-row>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="row mt-4">
              <div class="d-none d-sm-block col-sm-6 col-lg-3">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Afficher&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;enregistrements
                  </label>
                </div>
              </div>

              <div class="d-none d-lg-block col-md-6 text-center">
                <input id="radioType1" v-model="type" value="" type="radio" class="btn-check" autocomplete="off"/>
                <label class="btn btn-outline-info mb-0" for="radioType1">Tout</label>
                <input id="radioType2" v-model="type" value="1" type="radio" class="btn-check" autocomplete="off"/>
                <label class="btn btn-outline-success mb-0 mx-2" for="radioType2">Diapositives couleurs</label>
                <input id="radioType3" v-model="type" value="2" type="radio" class="btn-check" autocomplete="off"/>
                <label class="btn btn-outline-primary mb-0" for="radioType3">Négatifs noir et blanc</label>
              </div>

              <div class="d-none d-sm-block col-sm-6 col-lg-3">
                <div class="dataTables_filter text-right">
                  <label class="d-inline-flex align-items-center">
                    Recherche :
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Recherche..."
                        class="form-control-sm w-auto"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="d-block d-sm-none">
              <div class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Afficher&nbsp;
                  <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;enregistrements
                </label>
              </div>

              <div class="dataTables_filter">
                <label class="d-inline-flex align-items-center">
                  Recherche :
                  <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Recherche..."
                      class="form-control-sm w-auto"
                  ></b-form-input>
                </label>
              </div>
            </div>

            <div class="d-block d-lg-none text-center">
              <input id="radioType1sm" v-model="type" value="" type="radio" class="btn-check" autocomplete="off"/>
              <label class="btn btn-outline-info mb-0" for="radioType1sm">Tout</label>
              <input id="radioType2sm" v-model="type" value="1" type="radio" class="btn-check" autocomplete="off"/>
              <label class="btn btn-outline-success mb-0 mx-2" for="radioType2sm">Diapositives couleurs</label>
              <input id="radioType3sm" v-model="type" value="2" name="typeListe" type="radio" class="btn-check"
                     autocomplete="off"/>
              <label class="btn btn-outline-primary mb-0" for="radioType3sm">Négatifs noir et blanc</label>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  ref="pages_table"
                  :items="data"
                  :fields="fields"
                  :busy="isBusy"
                  striped
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  stacked="sm"
                  small
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

                <template #cell(exploitation_number)="data">
                  <span class="badge bg-info">{{ data.item.exploitation_number }}</span>
                </template>

                <template #cell(title)="data">
                  <span :title="data.item.title">{{ truncate(data.item.title, 50, '...') }}</span>
                </template>

                <template #cell(address)="data">
                  {{ data.item.address ? formatAddress(data.item.address) : '' }}
                </template>

                <template #cell(date)="data">
                  <div v-html="formatDate(data.item)"></div>
                </template>

                <template #cell(support)="data">
                  <span class="badge bg-secondary text-primary">{{
                      data.item.support ? data.item.support.title : ''
                    }}</span>
                </template>

                <template #cell(authors)="data">
                  <div v-if="data.item.authors">
                    <div class="me-1 d-inline-block"
                         v-for="(person, i) in data.item.authors"
                         :key="i"
                         @click="selectedPerson = person"
                         v-b-modal.modal-person
                    >
                      <person-inline :value="person"></person-inline>
                    </div>
                  </div>
                </template>

                <template #cell(persons)="data">
                  <div v-if="data.item.persons">
                    <div class="me-1 d-inline-block"
                         v-for="(person, i) in data.item.persons"
                         :key="i"
                         @click="selectedPerson = person"
                         v-b-modal.modal-person
                    >
                      <person-inline :value="person"></person-inline>
                    </div>
                  </div>
                </template>

                <template #cell(format)="data">
                  <span class="badge bg-secondary text-primary">{{
                      data.item.format ? data.item.format.string : ''
                    }}</span>
                </template>

                <template #cell(actions)="data">
                  <ul class="list-inline font-size-20 contact-links mb-0">
                    <li v-if="data.item.pages && data.item.pages.length > 0" class="list-inline-item text-success">
                      <a v-b-modal.modal-page-details @click="showPagesDetails(data.item.pages)" title="Afficher">
                        <i class="bx bx-image"></i>
                      </a>
                    </li>
                    <li class="list-inline-item text-info">
                      <a v-b-modal.modal-details @click="showDetails(data.item)" title="Afficher">
                        <i class="bx bx-show"></i>
                      </a>
                    </li>
                    <li v-if="canEdit" class="list-inline-item text-warning">
                      <a v-b-modal.modal-details @click="showEditForm(data.item)" title="Modify">
                        <i class="bx bx-pencil"></i>
                      </a>
                    </li>
                  </ul>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="float-end">
                  <strong>{{ totalRows }}</strong> enregistrements
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-details" :title-html="this.modalTitle" centered hide-footer
             size="lg"
             title-class="font-18"
             @hide="hideModal">
      <inventory-details v-if="displayDetails" :resource="this.selectedInventory"></inventory-details>

      <template v-if="canEdit">
        <inventory-form v-if="displayEditForm" :inventory="this.selectedInventory" v-on:cancel="hideModal"
                        v-on:submitted="hideModal"></inventory-form>
      </template>
    </b-modal>

    <b-modal id="modal-page-details" :title="this.modalTitle" centered hide-footer
             size="xl"
             title-class="font-18"
             @hide="hideModal">
      <b-tabs>
        <b-tab no-body v-for="(page, i) in selectedPages" :key="i" :title="page.NumPageAlbum">
          <page-profile v-if="displayPageDetails" :page="page"></page-profile>
        </b-tab>
      </b-tabs>
    </b-modal>

    <b-modal id="modal-person" centered hide-footer
             size="xl"
             title-class="font-18"
             @hide="selectedPerson = null">
      <person-details v-if="selectedPerson" :person="selectedPerson"></person-details>
    </b-modal>

    <b-modal v-if="canEdit" id="modal-import" :title="$t(`components.inventories.import`)" centered hide-footer
             size="md"
             title-class="font-18">
      <inventory-import v-on:cancel="hideModal"></inventory-import>
    </b-modal>
  </Layout>
</template>